"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metaItemStyles = void 0;
const lit_1 = require("lit");
exports.metaItemStyles = (0, lit_1.css) `
  :host {
    display: flex;
    justify-content: space-between;
  }

  :host([layout='stacked']) {
    flex-direction: column;
    gap: 0;
  }

  :host([layout='inline']) {
    justify-content: flex-start;
    gap: var(--space-2);
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWV0YS1pdGVtLnN0eWxlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm1ldGEtaXRlbS5zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkJBQXlCO0FBRVosUUFBQSxjQUFjLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7OztDQWVoQyxDQUFBIn0=